export default __webpack_public_path__ + "static/media/road-map-overlay.aa0491f4.png";